export default __webpack_public_path__ + "static/media/teles.e4ea45fd.mp4";